import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="bg-gradient-to-b from-blue-50 to-white py-20" data-id="element-81">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-82">
        <div className="text-center max-w-4xl mx-auto" data-id="element-83">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6" data-id="element-84">
            Legallama – Die smarte Kanzlei-Automation.
          </h1>
          <p className="text-xl sm:text-2xl text-gray-600 mb-8" data-id="element-85">
            Mehr Fälle. Weniger Aufwand. Höchste Datensicherheit – komplett in
            Deutschland gehostet.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12" data-id="element-86">
            <a href="mailto:hello@legallama.de?subject=Ich%20wünsche%20eine%20Demo%20zu%20Legallama" className="bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-blue-700 transition-colors" data-id="element-87">
              Kostenlose Live-Demo buchen
            </a>
            <button onClick={() => scrollToSection('features')} className="bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold text-lg border-2 border-blue-600 hover:bg-blue-50 transition-colors" data-id="element-88">
              Funktionsüberblick ansehen
            </button>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-4xl mx-auto" data-id="element-89">
            <div className="flex items-center justify-center gap-2 text-green-700" data-id="element-90">
              <CheckCircleIcon className="w-5 h-5" data-id="element-91" />
              <span className="font-medium" data-id="element-92">100% DSGVO-konform</span>
            </div>
            <div className="flex items-center justify-center gap-2 text-green-700" data-id="element-93">
              <CheckCircleIcon className="w-5 h-5" data-id="element-94" />
              <span className="font-medium" data-id="element-95">Daten in Deutschland</span>
            </div>
            <div className="flex items-center justify-center gap-2 text-green-700" data-id="element-96">
              <CheckCircleIcon className="w-5 h-5" data-id="element-97" />
              <span className="font-medium" data-id="element-98">KI auf eigenen Servern</span>
            </div>
            <div className="flex items-center justify-center gap-2 text-green-700" data-id="element-99">
              <CheckCircleIcon className="w-5 h-5" data-id="element-100" />
              <span className="font-medium" data-id="element-101">Sofort einsatzbereit</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}